import(/* webpackMode: "eager" */ "/vercel/path0/packages/nextjs/app/(app)/(blog)/(web)/[blogSlug]/error.tsx");
